import type { RectificationEventType } from "@/lib/api/rectification";

/**
 * Display labels for the engine's event vocabulary.
 *
 * The ids are NOT redeclared here — `RectificationEventType` is the generated
 * union from the backend's `EventType` enum, so this record is exhaustive by
 * type. Adding an event to the engine makes this a compile error until it is
 * labelled, and no label can name an event the scorer cannot score.
 */
export const EVENT_LABELS: Record<RectificationEventType, { en: string; hi: string }> = {
  marriage: { en: "Marriage", hi: "विवाह" },
  childbirth: { en: "Birth of a child", hi: "संतान जन्म" },
  career_start: { en: "First job / career start", hi: "पहली नौकरी" },
  promotion: { en: "Promotion", hi: "पदोन्नति" },
  job_loss: { en: "Job loss", hi: "नौकरी छूटना" },
  business_start: { en: "Started a business", hi: "व्यवसाय आरंभ" },
  property_purchase: { en: "Bought property", hi: "संपत्ति क्रय" },
  relocation_abroad: { en: "Moved abroad", hi: "विदेश गमन" },
  higher_education: { en: "Higher education", hi: "उच्च शिक्षा" },
  major_illness: { en: "Major illness", hi: "गंभीर रोग" },
  accident: { en: "Accident", hi: "दुर्घटना" },
  parent_loss: { en: "Loss of a parent", hi: "माता-पिता का वियोग" },
  financial_gain: { en: "Major financial gain", hi: "बड़ा आर्थिक लाभ" },
  financial_loss: { en: "Major financial loss", hi: "बड़ी आर्थिक हानि" },
};

export const EVENT_TYPE_IDS = Object.keys(EVENT_LABELS) as RectificationEventType[];

/** Three events is the floor below which confidence can never exceed "low". */
export const MIN_USEFUL_EVENTS = 3;
